import React from 'react';
import {
    Alert,
    Box,
    Button,
    CircularProgress,
    Typography,
} from "@mui/material";
import { PhoneAndroidRounded } from "@mui/icons-material";
import { ValidatedTextField } from "../../../components/ValidatedTextField";

const _LoginPhoneStep = ({
    status,
    STATUS_ENUM,
    mobileValidator,
    smsError,
    canSendCode,
    onSubmitPhone,
}) => {
    return (
        <Box>
            <Typography variant="body2" sx={{ fontWeight: 700, mb: 1, color: 'text.primary' }}>
                شماره همراه مدیر سازمان
            </Typography>

            <ValidatedTextField
                label="شماره موبایل (مثال: ۰۹۱۲۳۴۵۶۷۸۹)"
                variant="outlined"
                name="phoneNumber"
                isMobile={true}
                validator={mobileValidator}
                disabled={status !== STATUS_ENUM.CLEAR}
                required={true}
                fullWidth
                size="medium"
                slotProps={{
                    input: {
                        endAdornment: <PhoneAndroidRounded sx={{ color: 'primary.main', fontSize: 22 }} />,
                    },
                    htmlInput: {
                        maxLength: 11
                    }
                }}
            />

            {smsError && (
                <Alert severity="error" sx={{ mt: 1.5, borderRadius: 2.5, fontSize: '0.82rem' }}>
                    {smsError}
                </Alert>
            )}

            {status === STATUS_ENUM.CLEAR && (
                <Button
                    color="primary"
                    disabled={!canSendCode || status === STATUS_ENUM.LOADING_SEND_SMS}
                    type="submit"
                    variant="contained"
                    fullWidth
                    sx={{
                        mt: 2.5,
                        borderRadius: 3,
                        py: 1.2,
                        fontWeight: 800,
                        fontSize: '0.9rem',
                        boxShadow: '0 4px 14px rgba(28, 139, 156, 0.3)'
                    }}
                >
                    ارسال کد یکبار مصرف
                </Button>
            )}

            {status === STATUS_ENUM.LOADING_SEND_SMS && (
                <Button
                    disabled
                    variant="contained"
                    fullWidth
                    sx={{ mt: 2.5, borderRadius: 3, py: 1.2 }}
                >
                    <CircularProgress size={22} color="inherit" sx={{ mr: 1 }} />
                    در حال ارسال پیامک...
                </Button>
            )}
        </Box>
    );
};

export default _LoginPhoneStep;
